services.service('InvestService', ['', function () {

}]);